/**
 * The Ctrl+K palette's "ล่าสุด" (palette/model.ts reads and writes it): localStorage, per person AND
 * workspace. Forgotten together with the rest of the per-person device state when the session
 * changes hands (app/session.tsx `newIdentity`: sign-out, a sign-in this browser has not seen,
 * another account) — on a shared PC the next person's palette must not list what the previous one
 * opened (letter subjects and numbers, file names, task titles, chats).
 *
 * Only the key and the clearing live here, so the app shell (which signs people out) does not carry
 * the palette's code.
 */
export const RECENT_PICKS_KEY = 'xc.palette.recent';

export function forgetRecentPicks(): void {
  try {
    localStorage.removeItem(RECENT_PICKS_KEY);
  } catch {
    /* private mode / storage off */
  }
}
